import React, {Component} from "react";
import School from "../models/School";
import {SchoolSchedule} from "../models/SchoolSchedule";
import {friendlySchoolName} from "../utils/Utils";
import ApiService from "./ApiService";
import * as _ from "lodash";
import {IDropdownOption} from "office-ui-fabric-react";
import LoadingCard from "./LoadingCard";
import WorkloadQueryControls from "./pages/admin/workloads/WorkloadQueryControls";
import SchoolScheduleListRow from "./SchoolScheduleListRow";

interface SchoolScheduleListProps
{
    school: School;
    apiService: ApiService;
}

interface SchoolScheduleListState
{
    schoolSchedules?: SchoolSchedule[];
    workloadAndPlaylistOptions?: IDropdownOption[];
    namesWithExistingSchedules: string[];
}

export default class SchoolScheduleList extends Component<SchoolScheduleListProps,SchoolScheduleListState>
{
    constructor(props: Readonly<SchoolScheduleListProps>) {
        super(props);
        
        this.state = {
            schoolSchedules: undefined,
            namesWithExistingSchedules: []
        }
    }

    public async componentDidMount() {

        if (this.props.school !== undefined) {
            await this.fetchSchedules()
        }
        
        const workloadAndPlaylistOptions = await WorkloadQueryControls.fetchWorkloadAndPlaylistOptions(this.props.apiService);
        this.setState({
            workloadAndPlaylistOptions: workloadAndPlaylistOptions
        });
    }


    async componentDidUpdate(prevProps: Readonly<SchoolScheduleListProps>, prevState: Readonly<SchoolScheduleListState>, snapshot?: any) {

        if (this.props.school && this.props.school !== prevProps.school) {
            await this.fetchSchedules();
        }
    }
    
    private fetchSchedules = async (): Promise<void> => {
        if(this.props.school)
        {
            const schoolSchedules = await this.props.apiService.getSchoolSchedules(this.props.school);
            const namesWithExistingSchedules = schoolSchedules.map((s) => s.name);
            this.setState({
                schoolSchedules: _.sortBy(schoolSchedules, ["name"]),
                namesWithExistingSchedules
            });
        }

    }
    
    public render() {

        
        if(this.state.schoolSchedules === undefined || this.state.workloadAndPlaylistOptions === undefined)
        {
            return <LoadingCard/>;
        }
        
        const rows = this.state.schoolSchedules.map((schedule) => <SchoolScheduleListRow school={this.props.school} workloadAndPlaylistOptions={this.state.workloadAndPlaylistOptions!} schedule={schedule} key={schedule.name} namesWithExistingSchedules={this.state.namesWithExistingSchedules} onSave={this.fetchSchedules}/> );

        return (
            <div className="flex-row">
                <div className="cdb-table flex-item--flex-1">

                    <div className="card__header">
                        <span className={"card__title"}>{this.props.school ? `Schedules for ${friendlySchoolName(this.props.school)}` : ""}</span>
                    </div>

                    <div className="cdb-table__row cdb-table__row--header">
                        <div className="cdb-table__cell flex-item--flex-8">Name</div>
                        <div className="cdb-table__cell flex-item--flex-8">Schedule</div>
                        <div className="cdb-table__cell flex-item--flex-8">Last Run</div>
                        <div className="cdb-table__cell flex-item--flex-8">Next Run</div>
                        <div className="cdb-table__cell flex-item--flex-4">Enabled</div>
                        <div className="cdb-table__cell flex-item--flex-4"></div>
                        <div className="cdb-table__cell flex-item--flex-1"></div>
                    </div>
                    {rows}
                    <div className="cdb-table__row"/>
                    <div className="cdb-table__row"/>
                    <SchoolScheduleListRow school={this.props.school} workloadAndPlaylistOptions={this.state.workloadAndPlaylistOptions} schedule={undefined} key={"new"} className={"p-075rem"} namesWithExistingSchedules={this.state.namesWithExistingSchedules} onSave={this.fetchSchedules}/>
                </div>
            </div>
        );
    }
}